module.exports = __webpack_public_path__ + "img/logo-white.b61ca70b.png";